import { type ReactNode, useState } from 'react';
import { DonutChart, type DonutSlice } from '@/components/ui/donut-chart';
import { DonutLegend } from '@/components/ui/donut-legend';

const TITLE =
  'text-[11px] font-medium uppercase tracking-wider text-text-tertiary/50';

// Hovering either the ring or a legend row dims the other slices in both.
// It is an enhancement only — every label, share and count is already
// written in the legend, so nothing is reachable by hover alone.
function DonutBody({ slices }: { slices: DonutSlice[] }): ReactNode {
  const [activeId, setActiveId] = useState<string | null>(null);
  if (slices.length === 0) {
    return (
      <p className="py-lg text-xs text-text-tertiary">Sin datos todavía</p>
    );
  }
  return (
    <div className="flex items-center gap-base">
      <DonutChart slices={slices} activeId={activeId} onHover={setActiveId} />
      <DonutLegend slices={slices} activeId={activeId} onHover={setActiveId} />
    </div>
  );
}

export function DistributionDonut({
  title,
  slices,
}: {
  title: string;
  slices: DonutSlice[];
}): ReactNode {
  return (
    <div className="space-y-md">
      <p className={TITLE}>{title}</p>
      <DonutBody slices={slices} />
    </div>
  );
}
